<script setup>
import { computed, inject } from 'vue';
import { flowThreadContextKey } from './flowThreadContext';

const props = defineProps({
  node: {
    type: Object,
    required: true,
  },
});

const context = inject(flowThreadContextKey);
const hasBodyValue = computed(() => Boolean(props.node.config?.body?.trim?.()));
const messageBody = computed(() => props.node.config?.body || '');
const messageMetaClass = 'text-n-slate-10';
</script>

<template>
  <div class="bg-[#dcf8c6] px-3 py-2.5">
    <p
      class="whitespace-pre-wrap text-[12px] leading-5"
      :class="hasBodyValue ? 'text-n-slate-12' : 'text-n-slate-9'"
    >
      {{ messageBody || context.uiCopy.inlineTextPlaceholder }}
    </p>
    <div class="mt-1.5 flex items-center justify-end gap-1 text-[10px]">
      <span :class="messageMetaClass">{{ context.uiCopy.timestamp }}</span>
      <i class="i-lucide-check-check text-[11px] text-[#53bdeb]" />
    </div>
  </div>
  <div class="bg-white px-2 py-2">
    <div class="grid grid-cols-2 gap-1.5">
      <div
        v-for="(card, index) in node.config?.cards || []"
        :key="`${node.id}_card_${index}`"
        class="min-w-0 overflow-hidden rounded-[0.95rem] border border-black/5 bg-white"
      >
        <div class="h-[4.75rem] bg-n-slate-2">
          <img
            v-if="card.mediaUrl || card.mediaLink"
            :src="card.mediaUrl || card.mediaLink"
            alt=""
            class="h-full w-full object-cover"
          />
        </div>
        <div class="p-2 text-center">
          <div
            class="line-clamp-2 text-[12px] font-medium leading-4"
            :class="card.body ? 'text-n-slate-12' : 'text-n-slate-9'"
          >
            {{ card.body || context.uiCopy.inlineTextPlaceholder }}
          </div>
          <div
            class="mt-1.5 rounded-lg border border-[#25d366]/20 bg-[#25d366]/5 px-2 py-1 text-[11px] font-semibold"
            :class="card.buttonText ? 'text-[#128c7e]' : 'text-[#128c7e]/55'"
          >
            {{ card.buttonText || context.uiCopy.branchPlaceholder }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
